import { FC } from 'react';
import { CircularProgress } from '@mui/material';
import * as Styled from './styled';
import type { Props } from './types';

export const Loader: FC<Props> = ({ isLoading = false, forDetail = false }) => {
  if (!isLoading) {
    return null;
  }

  return (
    <Styled.LoaderWrapper forDetail={forDetail}>
      <CircularProgress />
    </Styled.LoaderWrapper>
  );
};
